import { Prescription } from '@/models';
import { GenericService } from '../generic.service';

export class JourneyPrescriptionService extends GenericService<Prescription> {
  constructor(patientId: string, journeyId: string) {
    super();
    this.endpoint = `/menicon/v1/patients/${patientId}/journeys/${journeyId}/prescriptions`;
  }
}
